import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#2C5F5D] text-white py-12">
      <div className="max-w-6xl mx-auto px-4">
        {/* ランキングへの目立つリンク */}
        <div className="mb-10 text-center">
          <Link
            to="/ranking"
            className="inline-flex items-center gap-3 bg-white text-[#2C5F5D] font-bold px-8 py-4 rounded-2xl transition-all shadow-lg hover:shadow-xl hover:scale-105 cursor-pointer"
          >
            <i className="ri-trophy-line text-2xl"></i>
            <span className="text-lg">人気クレジットカード比較ランキングはこちら</span>
            <i className="ri-arrow-right-line text-xl"></i>
          </Link>
        </div>

        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
                <i className="ri-bank-card-line text-[#2C5F5D] text-lg"></i>
              </div>
              <span className="text-lg font-bold">クレカ比較ナビ</span>
            </div>
            <p className="text-sm text-white/80">
              あなたにぴったりのクレジットカードが見つかる比較サイト
            </p>
          </div>

          <div>
            <h3 className="font-bold mb-4">人気カード</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/mitsui" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  三井住友カード（NL）
                </Link>
              </li>
              <li>
                <Link to="/rakuten" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  大手ECモール系カード
                </Link>
              </li>
              <li>
                <Link to="/suruga" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  地方銀行系スピード発行カード
                </Link>
              </li>
              <li>
                <Link to="/dcard" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  dカード GOLD U
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold mb-4">カテゴリー</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/ranking" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  ランキング
                </Link>
              </li>
              <li>
                <Link to="/comparison" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  比較
                </Link>
              </li>
              <li>
                <Link to="/free" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  年会費無料
                </Link>
              </li>
              <li>
                <Link to="/highreturn" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  高還元率
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold mb-4">人気記事</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/articles/free-annual-fee" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  年会費無料カード
                </Link>
              </li>
              <li>
                <Link to="/articles/high-return-rate" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  高還元率カード
                </Link>
              </li>
              <li>
                <Link to="/articles/student-cards" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  学生向けカード
                </Link>
              </li>
              <li>
                <Link to="/articles/rakuten-vs-mitsui" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  大手ECモール系vs三井住友比較
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 text-center">
          <p className="text-sm text-white/60">
            © 2026 クレカ比較ナビ. All rights reserved. | 
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="ml-2 hover:text-white transition-colors cursor-pointer">
              Powered by Readdy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
